let currentIndex = 0;

  // Function to render product cards in the carousel
  function renderProductCard(product) {

  // Generate the variant options as a dropdown if there are multiple variants
  const variantOptions = product.variants.map(variant => {
    const price = (variant.price / 100).toFixed(2);
    return `<option value="${variant.id}">${variant.title} - £${price}</option>`;
  }).join('');

  return `
    <div class="recommended-product">
      <div class="recommended-product-details-image">
        <a href="/products/${product.handle}">
          <img src="${product.featured_image}" alt="${product.title}" style="width: 100%;" />
        </a>
      </div>
      <div class="recommended-product-details">
        <p>${product.title}</p>
        <p><strong>From £${(product.variants[0].price / 100).toFixed(2)}</strong></p>
        ${product.variants.length > 1 
          ? `<select class="variant-selector" data-product-id="${product.id}">${variantOptions}</select>`
          : ''}
        <button class="add-to-cart-btn btn btn--small" 
          data-variant-id="${product.variants[0].id}">
          Add to Cart
        </button>
      </div>
    </div>
  `;
}

  // Function to update the carousel position
  function updateCarousel() {
    const track = document.getElementById('recommended-carousel-track');
    const totalItems = track.children.length;
    const carouselWidth = document.getElementById('recommended-carousel').offsetWidth;

    // Update transform to show the current product
    track.style.transform = `translateX(-${currentIndex * carouselWidth}px)`;

    // Disable buttons at the edges
    document.getElementById('carousel-prev').disabled = currentIndex === 0;
    document.getElementById('carousel-next').disabled = currentIndex === totalItems - 1;
  }

  // Event listeners for carousel buttons
  document.getElementById('carousel-prev').addEventListener('click', (event) => {
    event.preventDefault(); // Prevent default behavior
    currentIndex = Math.max(0, currentIndex - 1); // Prevent index from going negative
    updateCarousel();
  });

  document.getElementById('carousel-next').addEventListener('click', (event) => {
    event.preventDefault(); // Prevent default behavior
    const track = document.getElementById('recommended-carousel-track');
    const totalItems = track.children.length;
    currentIndex = Math.min(totalItems - 1, currentIndex + 1); // Prevent index from exceeding total items
    updateCarousel();
  });

  // Function to fetch product recommendations for a specific product
  function fetchProductRecommendations(productId) {
    return fetch(`/recommendations/products.json?product_id=${productId}&limit=6`)
      .then(response => response.json())
      .then(data => {
        const track = document.getElementById('recommended-carousel-track');
        if (data && data.products && data.products.length > 0) {
          track.innerHTML = data.products
            .map(product => renderProductCard(product))
            .join('');
        } else {
          track.innerHTML = '<p>No recommendations available.</p>';
        }

        // Reset index on new render
        currentIndex = 0;
        updateCarousel();
      })
      .catch(error => console.error('Error fetching product recommendations:', error));
  }

  // Function to determine the first product in the cart and fetch recommendations
  
  function renderRecommendations(cart) {
    if (cart.items.length > 0) {
      const firstProductId = cart.items[0].product_id; // Get the product ID of the first cart item
      fetchProductRecommendations(firstProductId);
    } else {
      // Handle empty cart case
      const track = document.getElementById('recommended-carousel-track');
      track.innerHTML = '<p>No recommendations available.</p>';
    }
  }

  // Add event listener for Add to Cart buttons
  document.addEventListener('click', function (event) {
    if (event.target && event.target.classList.contains('add-to-cart-btn')) {
      event.preventDefault();
      const variantId = event.target.getAttribute('data-variant-id');
      addToCart(variantId);
    }
  });

  document.addEventListener('change', function (event) {
  if (event.target && event.target.classList.contains('variant-selector')) {
    const selectedVariantId = event.target.value; // Get selected variant ID
    const productCard = event.target.closest('.recommended-product');
    const addToCartButton = productCard.querySelector('.add-to-cart-btn');
    
    // Update the Add to Cart button's variant ID
    addToCartButton.setAttribute('data-variant-id', selectedVariantId);
  }
});

  // Function to add the product to the cart
  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(response => response.json())
      .then(() => {
        // Dispatch the theme's custom event to rebuild the cart drawer
        document.dispatchEvent(new CustomEvent('cart:build'));

        // Show a success message in the cart drawer
        const message = document.getElementById('cart-success-message');
        if (message) {
          message.innerText = 'Product added to your cart!';
          message.style.display = 'block';

          // Hide the success message after 3 seconds
          setTimeout(() => {
            message.style.display = 'none';
          }, 3000);
        }
      })
      .catch(error => console.error('Error adding product to cart:', error));
  }

  // Fetch cart and update recommendations on page load or cart changes
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      renderRecommendations(cart); // Initial render on page load
    })
    .catch(error => console.error('Error fetching cart:', error));

  document.addEventListener('cart:updated', function () {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        renderRecommendations(cart); // Re-render recommendations after cart update
      })
      .catch(error => console.error('Error fetching updated cart:', error));
  });